import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SimpleModal, DialogModal } from 'components';
import FilterPortal from '../../portals/filter-portal';
import SearchIcon from '@tradera/tradera-ui/icons/search.svg?jsx';

class FilterBrandsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: ''
        };
    }

    handleInputChange = input => {
        this.setState({
            search: input.substr(0, 10)
        });
    };

    renderBrandsList = brands => {
        const { handleBrandChange, filterBrands } = this.props;
        const { parameter, selectedValues } = filterBrands;
        return brands.map((brand, index) => {
            return (
                <label key={index} className="form-check d-flex">
                    <input
                        className="flex-grow-0 form-check-input"
                        type="checkbox"
                        id={brand.value}
                        name="brand"
                        value="brandFilter"
                        defaultChecked={selectedValues.includes(brand.value)}
                        onClick={() =>
                            handleBrandChange(parameter, brand.value)
                        }
                    />
                    <span className="flex-grow-1 ml-3 form-check-label text-dark text-truncate">
                        {brand.name}
                    </span>
                    <span className="flex-grow-0 ml-3 text-muted">
                        {brand.count}
                    </span>
                </label>
            );
        });
    };

    render() {
        const { filterBrands, onClose } = this.props;
        const { options: brands } = filterBrands;
        const { search } = this.state;
        if (!brands) {
            return null;
        }
        const filteredBrands = brands
            .filter(brand => {
                return brand.name.toLowerCase().includes(search.toLowerCase());
            })
            .sort((a, b) => {
                if (a.name > b.name) {
                    return 1;
                } else if (a.name < b.name) {
                    return -1;
                } else {
                    return 0;
                }
            });
        return (
            <DialogModal onDismiss={() => onClose()}>
                <div className="filter-brands-modal d-flex flex-column rounded p-5">
                    <div className="form-control-with-icon flex-grow-0">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Sök efter varumärken"
                            aria-label="Sök  efter varumärken"
                            aria-describedby="search-brand"
                            value={search}
                            autoFocus={true}
                            onChange={e =>
                                this.handleInputChange(e.target.value)
                            }
                        />
                        <SearchIcon className="icon icon-dark" />
                    </div>
                    {filteredBrands.length > 0 ? (
                        <div className="filter-brands-container flex-grow-1 my-5 px-3">
                            <div className="text-columns-lg-4 text-columns-md-3 text-columns-sm-2 text-columns--gap-4">
                                {this.renderBrandsList(filteredBrands)}
                            </div>
                        </div>
                    ) : (
                        <p>Inga matchande varumärken hittade</p>
                    )}
                    <div className="flex-grow-0">
                        <button
                            className="btn btn-primary btn-fluid"
                            onClick={() => onClose()}>
                            Stäng
                        </button>
                    </div>
                </div>
            </DialogModal>
        );
    }
}

FilterBrandsModal.propTypes = {
    filterBrands: PropTypes.object,
    handleBrandChange: PropTypes.func,
    onClose: PropTypes.func
};

export default FilterBrandsModal;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/filters/brands/filter-brands-modal.jsx